import { z } from 'zod';

import { NavColumn } from '../models/nav-column';
import { NavMenuColumn } from '../models/nav-menu-column';

const NavLinkSchema = z.object({
  link_title: z.string().min(1).nullable(),
  mobile_title: z.string().nullable(),
  link_url: z.string().min(1).nullable(),
  link_url_as1: z.string().min(1).nullable(),
  link_url_as2: z.string().min(1).nullable(),
  link_url_as3: z.string().min(1).nullable(),
  link_url_as4: z.string().min(1).nullable(),
  link_icon: z.string().nullable(),
});

const createMenuSchema = () =>
  z.array(
    z.object({
      main_link_title: z.string(),
      main_link_url: z.string(),
      [`menu_columns`]: z.array(NavMenuColumn),
    })
  );

const menuSchemas: { [key: string]: ReturnType<typeof createMenuSchema> } = {};

for (let i = 1; i <= 5; i++) {
  menuSchemas[`menu_${i}`] = createMenuSchema();
}

const schema = z.object({
  title: z.string().min(1),
  pattern: z.string().min(1),
  priority: z.string().min(1),
  utility_links: z.array(NavLinkSchema),
  menu_1: createMenuSchema(),
  menu_2: createMenuSchema(),
  menu_3: createMenuSchema(),
  menu_4: createMenuSchema(),
  menu_5: createMenuSchema(),
});

export const HeaderResponseSchema = z.array(schema);

export type HeaderResponse = z.infer<typeof HeaderResponseSchema>;

export type NavLinks = z.infer<typeof NavLinkSchema>;

export const HeaderError = z.object({ message: z.string() });

export type HeaderError = z.infer<typeof HeaderError>;
